
angular.module('bmsApp.directives').factory('DocumentSvc', [
	'$q',
	'$rootScope',
	'$modal',
	'notify',
	'CRUDSvc',
	'DOCUMENT_API', function (
		$q,
		$rootScope,
		$modal,
		notify,
		CRUDSvc,
		DOCUMENT_API) {

	return {
		index: function (params) {
			return CRUDSvc.get(DOCUMENT_API.INDEX, params);
		},
		delete: function (document) {
			return CRUDSvc.get(DOCUMENT_API.DELETE + document.id);
		},
		options: function (params) {
			return CRUDSvc.get(DOCUMENT_API.OPTIONS, params);
		},
		optionsByCustomer: function (customerId, params) {
			var newParams = angular.extend({}, params, {
				filter: {
					customer: customerId
				}
			});
			return CRUDSvc.get(DOCUMENT_API.OPTIONS, newParams);
		},
		optionsByEnquiry: function (enquiryId, params) {
			var newParams = angular.extend({}, params, {
				filter: {
					enquiry: enquiryId
				}
			});
			return CRUDSvc.get(DOCUMENT_API.OPTIONS, newParams);
		},
		optionsByTgJob: function (jobId, params) {
			var newParams = angular.extend({}, params, {
				filter: {
					tgJob: jobId
				}
			});
			return CRUDSvc.get(DOCUMENT_API.OPTIONS, newParams);
		},
		optionsBySmJob: function (jobId, params) {
			var newParams = angular.extend({}, params, {
				filter: {
					smJob: jobId
				}
			});
			return CRUDSvc.get(DOCUMENT_API.OPTIONS, newParams);
		},
		optionsByMmJob: function (jobId, params) {
			var newParams = angular.extend({}, params, {
				filter: {
					mmJob: jobId
				}
			});
			return CRUDSvc.get(DOCUMENT_API.OPTIONS, newParams);
		}
	};

}]).constant('DOCUMENT_API', {
	INDEX: 'api/globalDocument/index',
	DELETE: 'api/document/delete/',
	OPTIONS: 'api/document/options'
});
